import 'antd/dist/antd.css';
import './index.scss';

require('../components/Alert/style');
require('../components/Box/style');
require('../components/Button/style');
require('../components/Carousel/style');
require('../components/Checkbox/style');
require('../components/CheckboxSelect/style');
require('../components/Code/style');
require('../components/Dropdown/style');
require('../components/DropdownInput/style');
require('../components/DropdownList/style');
require('../components/FileUpload/style');
require('../components/Uploader/style');
require('../components/Form/style');
require('../components/Icon/style');
require('../components/Input/style');
require('../components/Label/style');
require('../components/LabelSelect/style');
require('../components/Loading/style');
require('../components/Message/style');
require('../components/Modal/style');
require('../components/SideModal/style');
require('../components/MultiInput/style');
require('../components/NoResult/style');
require('../components/Pagination/style');
require('../components/Popover/style');
require('../components/Radio/style');
require('../components/Select/style');
require('../components/Setter/style');
require('../components/Switch/style');
require('../components/Tab/style');
require('../components/Table/style');
require('../components/Timeline/style');
require('../components/Tooltip/style');
require('../components/Truncate/style');
require('../components/TimePicker/style');
require('../components/AreaLinkage/style');
require('../components/PageTitle/style');
require('../components/Transfer/style');
require('../components/SearchInput/style');
require('../components/InputMatch/style');
require('../components/MiniSearchInput/style');
require('../components/QuickFilter/style');
require('../components/Slider/style');
require('../components/SmartInput/style');
require('../components/AutoRefresh/style');
require('../components/Collapse/style');
require('../components/Spin/style');
require('../components/SingleCollapse/style');
require('../components/TreeSelect/style');
require('../components/Tree/style');